import React from 'react';
import PropTypes from 'prop-types';
import { getSortedFacilities } from '../../../../src/web/utils/distanceUtils';
import FacilitiesListEntry from '../../../components/stateless/FacilitiesListEntry';
import styles from './styles.scss';
import { calculateDistance } from '../FacilitySearchBar/useFacilityManager';
import useLocationManager from '../../../hooks/useLocationManager';

const propTypes = {
  facilities: PropTypes.arrayof(
    PropTypes.shape({
      address: PropTypes.shape({
        latitude: PropTypes.string,
        longitude: PropTypes.string,
      }),
    }),
  ).isRequired,
  enabledFacilities: PropTypes.PropTypes.shape({
    address: PropTypes.shape({
      latitude: PropTypes.string,
      longitude: PropTypes.string,
    }),
  }),
  user: PropTypes.shape({
    latitude: PropTypes.string,
    longitude: PropTypes.string,
  }).isRequired,
};

const defaultProps = {
  enabledFacilities: undefined,
};

const FacilityGroup = ({
  facilities = [],
  enabledFacilities,
  user,
  locale,
}) => {
  const { isLocationEnabled, currentLocation } = useLocationManager(true);

  // don't display an empty array or an array with only an empty object
  const hasFacilities = facilities.length && Object.keys(facilities[0]).length;
  if (!hasFacilities) {
    return <h2>There are no facilities for this client</h2>;
  }

  const sortedFacilities = isLocationEnabled
    ? getSortedFacilities(
      { latitude: currentLocation?.lat, longitude: currentLocation?.lon },
      user,
      facilities,
    )
    : facilities;

  let enabledLiveFacilities = [];
  if (enabledFacilities) {
    enabledLiveFacilities = sortedFacilities.filter(
      facility => enabledFacilities[facility.id],
    );
  } else {
    enabledLiveFacilities = sortedFacilities;
  }

  const hasEnabledFacilities = enabledLiveFacilities.length
    && Object.keys(enabledLiveFacilities[0]).length;

  if (!hasEnabledFacilities) {
    return <h2>Please select facilities for this group.</h2>;
  }

  return (
    <div>
      {enabledLiveFacilities.map(facility => (
        <div key={facility.id}>
          {/* eslint-disable-line react/no-array-index-key */}
          <FacilitiesListEntry
            facility={{
              ...facility,
              distanceFromCurrentUserInMiles: isLocationEnabled
                ? calculateDistance(
                  currentLocation?.lat,
                  currentLocation?.lon,
                  facility?.address?.latitude,
                  facility?.address?.longitude,
                )
                : facility?.distanceFromCurrentUserInMiles ?? 0,
            }}
            locale={locale}
            showLocation={isLocationEnabled}
          />
          <hr className={styles.border} />
        </div>
      ))}
    </div>
  );
};

FacilityGroup.propTypes = propTypes;
FacilityGroup.defaultProps = defaultProps;

FacilityGroup.fragments = {};

export default FacilityGroup;
